export default "__VITE_ASSET__rv241WNi__"